// extracted by mini-css-extract-plugin
export default {"signupConfirm":"ForgotPasswordConfirm_signupConfirm__csBH3","cntOuter":"ForgotPasswordConfirm_cntOuter__TPXNa"};